import { ModelCollection } from '@/modules/core/app/models/ModelCollection';
import { OtpType } from '@/modules/otp/enums/OtpType';
import { OtpContact } from '@/modules/otp/models/OtpContact';

export class OtpContactCollection extends ModelCollection<OtpContact> {
  constructor(items: OtpContact[] | OtpContactCollection | undefined) {
    super(items, OtpContact);
  }

  static mapModel(items: OtpContact[] | OtpContactCollection | undefined): OtpContactCollection {
    return new this(items);
  }

  get allVerifiedContacts(): OtpContact[] {
    return this.items?.filter((contact: OtpContact) => contact.isVerified) ?? [];
  }

  getVerifiedContactsByType(type: OtpType = OtpType.PHONE_NUMBER): OtpContact[] {
    return (
      this.items?.filter((contact: OtpContact) => contact.isVerified && contact.type === type) ?? []
    );
  }

  getUnverifiedContact(type: OtpType = OtpType.PHONE_NUMBER): OtpContact | undefined {
    return this.items?.find((contact: OtpContact) => !contact.isVerified && contact.type === type);
  }

  addUnverifiedContact(type: OtpType, value?: string): void {
    const isPhoneNumber: boolean = type === OtpType.PHONE_NUMBER;
    this.add(
      OtpContact.mapModel({
        type,
        phoneNumber: isPhoneNumber ? value : undefined,
        email: !isPhoneNumber ? value : undefined,
        isVerified: false
      })
    );
  }
}
